function Title({ titleName }) {
  document.title = titleName + " - Catalogue Reference";
}

export default Title;